import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	button: {
		marginTop: theme.spacing(3)
	}
}));

export default styles;
